export { default } from './Img';

export type Props = import('./Img').Props;
